import { L2CategoryId, L2CategorySeoNames } from '@gumtree/shared/src/util/category-mapping';

const convertNonStringToEmptyString = (price) => {
    if (typeof price !== 'string') {
        return '';
    }

    return price;
};

const convertZeroPriceToFree = (price: string) => {
    if (price === '£0.00') {
        return 'FREE';
    }

    return price;
};

export const removeTrailingZeros = (price: string | number | null | undefined) => {
    const priceString = convertNonStringToEmptyString(price);

    const priceWithFree = convertZeroPriceToFree(priceString);

    return priceWithFree.replace('.00', '');
};

export const setPriceToZeroIfFreebies = (
    price: string | number | null | undefined,
    l2CategoryId: L2CategoryId
) => {
    if (L2CategorySeoNames.freebies === l2CategoryId) {
        return '£0.00';
    } else {
        return price;
    }
};

export const isANumber = (value: any): boolean => {
    if (typeof value === 'number') return !isNaN(value);
    if (typeof value !== 'string') return false;

    const trimmedValue = value.trim();
    if (trimmedValue === '') return false;

    return !isNaN(Number(trimmedValue)) && isFinite(Number(trimmedValue));
};

/**
 * Formats a number into comma separated string with optional decimal places. E.g. expect(formatNumber(1234)).toBe('1,234');
 *
 * @param input - The number to format. If the input is not a number, it will be converted to a string.
 * @param decimalPlaces - Optional parameter to specify the number of decimal places to include.
 *                        If not provided, the number will be formatted without decimal places.
 * @returns A string representation of the input number with the specified decimal places.
 *          If the input is not a number, the function will return the string representation of the input.
 */
export function formatNumber(input: any, decimalPlaces?: number): string {
    // Handling non-numeric values
    if (!isANumber(input)) {
        return String(input);
    }

    // Configuration for toLocaleString
    const options: Intl.NumberFormatOptions = {};
    if (decimalPlaces !== undefined) {
        options.minimumFractionDigits = decimalPlaces;
        options.maximumFractionDigits = decimalPlaces;
    }

    // Formatting the number
    return (+input).toLocaleString(undefined, options);
}

export const numberToCurrency = (number, decimalPlaces = 0, currency = '£') =>
    `${currency}${formatNumber(number, decimalPlaces)}`;

export const formatPriceRange = (min, max) => `${numberToCurrency(min)} - ${numberToCurrency(max)}`;
